export default class ObjectUtil {
  /**
   * True for null, undefined, empty string, or an empty array.
   * @param {*} value
   * @returns {boolean}
   */
  static isBlank = (value) => {
    if (value == null || value === '') return true;
    return Array.isArray(value) && value.length === 0;
  }

  /**
   * Value equality that treats null and undefined as the same, and compares arrays by item.
   * @param {*} a
   * @param {*} b
   * @returns {boolean}
   */
  static isEqual = (a, b) => {
    if (a === b) return true;
    if (a == null && b == null) return true;
    if (Array.isArray(a) && Array.isArray(b)) {
      return a.length === b.length && a.every((value, index) => value === b[index]);
    }
    return false;
  }

  /**
   * Returns a copy of `object` without blank values (see {@link ObjectUtil.isBlank}).
   * @param {Object} object
   * @returns {Object}
   */
  static compact = (object = {}) => Object.fromEntries(
    Object.entries(object).filter(([, value]) => !this.isBlank(value))
  );
}
